import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";
import { FaCalendarXmark, FaPersonWalkingLuggage, FaSuitcase } from "react-icons/fa6";
import ViewLeave from "./view";
import EditLeave from "./edit";
import { MODULE_LEAVE } from "variables/constants";
import TeamAbsences from "./index";

const teamAbsencesRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Team Absences",
		basePath: "team-absences",
		mainComponent: <TeamAbsences />,
	    layout: "/console",	   
	    icon: <FaCalendarXmark className="icon-item" />,
	    subTitle:"Team Absence",
	    viewComponent: <ViewLeave />,
	    createComponent: <EditLeave />,
	    editComponent: <EditLeave />,
		level:5,
		moduleId: MODULE_LEAVE,
	})
]

export default teamAbsencesRoutes;